import React, { Component } from 'react';
import {ServiceItem} from '../components/serviceItem.js';
import {PageNav} from '../components/pageNav.js';
import {Footer} from '../components/footer.js';
import {Link} from 'react-router-dom';

export class Services extends Component {
    state = { 
        // just as in news.js, id corresponds to the number displayed in url

        // format must be either 'list' or 'text' exactly:
        // list: use key list equal to an array of strings to be displayed in a vertical, bulleted list under the card title
        // text: the entire string will be displayed and wrap around per line according to the dimensions of the containing card

        // the body key corresponds to the text that will appear in each instance page (after clicking more info on a card)
        // any additional keys can be accessed in src/components/serviceItem.js using this.props.info.keyName or this.props.info['keyName']
        services: [ 
	{ format: 'text', id: 1, title: 'Seismic Imaging Service', text: 'AGT provides advanced, best-in-class seismic imaging services to Oil and Gas Companies.', 
body: 'AGT offers a full range of seismic imaging services in both Time and Depth, 2D and 3D, Land and Marine. We have coupled patented seismic imaging technology with a unique hardware infrastructure that allows for unparalleled high-quality delivery at a lower cost than our competitors. We have multi-Petaflops of compute ensuring rigorous real-time data testing, workflow analysis and optimum parameterization all done with a quick turnaround time.',
body1: 'AGT’s Services utilizing AGT proprietary technology – “NovaSeis”:',
body2: 'Time and Depth Processing',
body3: "\xa0\xa0\xa0\xa0\xa0\xa0"+'+2D and 3D; ',
body4: "\xa0\xa0\xa0\xa0\xa0\xa0"+'+Land / Marine (NAZ, WAZ, Broadband, Nodal, etc.)',
body5: 'Forward Modeling – Visco-Elastic (Finite Element) and Acoustic',
body6: 'Research & Development',
body7: "\xa0\xa0\xa0\xa0\xa0\xa0"+'+35% of all capital is committed to R&D',
body8: "\xa0\xa0\xa0\xa0\xa0\xa0"+'+Customer Focused Results'},
{ format: 'list', id: 2, title: '3D RTM, Q-RTM & RTM GATHERS (ISO/VTI/TTI)', list: ['AVO compliant offset and angle gathers (patentpending)','Finite-difference Q-RTM (patent pending) 5X faster than traditional methods', 'Affordable high frequency (e.g., 50Hz) 3D RTM angle', 'Output every location in offset or angle domain.', 'Azimuthal Imaging & Least Squares', 'Least Squares QRTM, RTM'],},
{ format: 'list', id: 3, title: '5-D INTERPOLATION (patent pending)', list: ['POCS/MWNI','Anti-leakage and Anti-aliasing','Fills large data gaps'],},
{ format: 'list', id: 4, title: 'FULL WAVEFORM INVERSION (Refraction/Reflection)', list: ['Beat-Tone FWI algorithm that does not require low-frequency data (patent)','Fast convergence rate (efficient computation of second-order derivative)', 'Highly automatic algorithm, minimum user interaction','Optimized workflows designed for various categories of seismic data with Q','FWI Imaging'],},
{ format: 'list', id: 5, title: '3D KIRCHHOFF DEPTH & TIME MIGRATION', list: ['Q, (ISO/HTI/VTI), VTI/TTI Orthorhombic','Designed for large 3D datasets and high-resolution','OVT’s/Azimuthal Imaging','Least Squares'],},
{ format: 'list', id: 6, title: 'DIFFRACTION IMAGING', list: ['Double stage reflection energy suppression'],},
{ format: 'list', id: 7, title: 'FORWARD-MODELING – Full Physics', list: ['Finite Element / Finite Difference.','3D Acquisition Design / Reservoir Properties'],},
{ format: 'list', id: 8, title: '3D TOMOGRAPHIC VELOCITY MODEL BUILDING WITH Q, ORTHORHOMBIC', list: ['High-resolution tomography for small velocity anomalies','Superior fault definition and improved image','Global automatic residual depth move-out picking','Geology structural conformed inversion','Sub-salt velocity update with RTM dense angle gathers, shot index gathers and offset gathers'],},
{ format: 'list', id: 9, title: 'MACHINE LEARNING: AI INITIATIVES', list: ['Automatic First Break Picking/Salt Picking','Full Waveform Inversion','Noise Attenuation- Land','Acoustic/Elastic, ISO/VTI/TTI/Orthorhombic, Q','Large Scale Seismic Modeling Capability','Surface/Seafloor Topography','Variable Gridding','VSP/Seafloor Multi-component Recording'],},
{ format: 'list', id: 10, title: 'SIGNAL PROCESSING', list: ['Refraction/Diving Tomography/Statics','Residual Statics – non pilot based','Deblending','Deghosting/Debubble','Noise, Ground Roll and Multiple Attenuation','Bandwidth Extension/ Coherency','SWD / SRME / IME (Data and Model Based)'],},
{ format: 'list', id: 11, title: 'AVO- QEYE Labs', list: ['AVO Gather Conditioning','Well Log Correlation/ Phase Verification','AVO Cross-plotting/Elastic Modeling','Inversion and Rock Physics'],}
	/*{ format: 'list', id: 4364364, title: 'AGT’s Proprietary Technology Service Offerings', list: ['Time Imaging / Signal Processing', 'Migration & Velocity Model Building', 'Forward Modeling'], 
body:'1  Time Imaging / Signal Processing',
body1: '●	PSTM (VTI/HTI)',
body2:'●	5D Interpolation',
body3:'●	Deghosting',
body4:'●	Debubblen',
body5:'●	3D SRME',
body6:'●	Multiple & Noise Attenuation',
body7:'2  Migration & Velocity Model Building',
body8:'●	Refraction Tomography',
body9:'●	Residual Statics',
body10:'●	2D / 3D Time & Depth',
body11:'●	ISO,VTI,TTI, Orthorhombic',
body12:'●	High Frequency RTM as a standard (+50HZ).',
boay13:'●	Land/Marine (Nodal, Simultaneous, NAZ, WAZ, Broadband)',
body14:'3  Forward Modeling',
body15:'●	Acoustic/Elastic',
body16:'●	Finite Element',
body17:'●	Finite Difference',
body18:'●	Full Physics ',
body19:'●	ISO, VTI, TTI, Orthorhombic, Q',
body20:'●	VSP/Sea-Floor multi-component recording'},
            { format: 'list', id: 3, title: 'Forward Modelling / Seismic Simulation Services', list: ['patent protected GPU technology', '3D acquisition design, 4D studies'], 
body: 'AGT is a world leader in forward modelling software technologies and services having written a superior patent protected technology suite utilizing an efficient implementation on GPU hardware infrastructure. A large quantity of proprietary forward modelling projects have been completed for a number of industry related companies including a number of projects with  SEG Advanced Modeling Corporation (SEAM).  SEAM is a consortia of large oil and oil service companies who have subscribed to various geologic model analysis over the years.  AGT has won multi-year numerous projects through competitive with SEAM.',
body1: 'AGT continues to deliver technically superior results cost effectively especially for solving very large high frequency visco-elastic modeling studies.  Internal technical and/or exorbitant computational cost challenges has resulted in large oil/service companies reaching out for these modeling services provided by AGT. AGT has become the service company of choice for oil companies when running very complex large modeling data sets due to these internal limitations.',
body2: 'Services for modeling include 3D acquisition design (i.e. Nodal surveys), velocity model building analysis, algorithm development and reservoir analysis  along with 4D studies.'},
            { format: 'list', id: 2, title: 'Seismic Data Processing and Imaging', list: ['2D/3D Time', '2D/3D Depth', 'Land/Marine (NAZ, WAZ, Broadband, Nodal, etc.)'], 
body: 'AGT offers a true integration of teams, platforms, data and applications to help our clients create value by delivering to them fully processed seismic volumes that enable the reduction of exploration risks and the uncertainties associated with oil and gas field development.',
body1:'We are committed to exceeding the expectations of all our stakeholders. We aspire to be demonstrably the leading geophysical services provider utilizing proprietary and patented technology implementations to support our customer base. This is achievable through our professional, dedicated teams coupled with our leading-edge technology.',
body2:'Our services are offered in our processing centers in Houston, Beijing and with partner companies in Delhi, Kuala Lumpur and Buenos Aires.',
body3:' AGT continues to work in many of the worlds geologic basins throughout onshore US, GOM, Shelf, Mexico, Colombia, Brazil, West Africa, SE Asia, and China.  AGT geoscientists combine expertise, innovation, and training with a global knowledge management network.'}*/
            
        ],//end of services:
        /*servicesReset:[
            { format: 'list', id: 3, title: 'Research & Development', list: ['40% of all capital is committed to R&D', 'Customer Focused Results - technology roadmap is adaptable', 'Rapid Technology Implementation - i.e. AVO Compliant RTM Gathers, Q', 'Nimble; technology roadmap adaptable to clients\' needs'], body: 'Body text to be added.'},
            { format: 'list', id: 2, title: 'Migration & Velocity Model Building', list: ['2D/3D Time', '2D/3D Depth', 'Land/Marine (NAZ, WAZ, Broadband, Nodal, etc.)'], body: 'Body text to be added.'},
            { format: 'text', id: 1, title: 'Seismic Imaging Service', text: 'AGT provides advanced, best-in-class seismic imaging services to Oil and Gas Companies.', body: 'Body text to be added.'}
        ], */// a copy of the entirety of news to be saved every time news is modified by a function call, since there is currently
        // no filter for this page, it's useless, but I'm keeping it here in case we decide to apply filters later. There's 
        // no need to update this at all until filters are implemented, so you can leave it alone unlike the news/technology pages
        numServiceItems: 6, // number of news entries to be displayed per page
        page: 0,
        title: 'SERVICES'
    }

    componentDidMount() {
        document.title = 'AGT - Services';
    }
    
    // convert numServiceItems at a time news entries into NewsItem components
    formatService = () => {
        var serviceJSX = [];
        let i = this.state.page * this.state.numServiceItems;
        while(i<this.state.services.length && i<this.state.page*this.state.numServiceItems + 6){
            let dict = this.state.services[i];
            serviceJSX.push(<ServiceItem info={dict}/>)
            i++;
        }
        if(serviceJSX.length > 0)
            return serviceJSX;
        else
            return <span class="txt subheading ml-2 mt-2">Nothing on this page.</span>
    }

    incrementPage = () => {
        const page = this.state.page + 1;
        this.setState({page});
    }

    incrementPageTwice = () => {
        const page = this.state.page + 2;
        this.setState({page});
    }
    
    decrementPage = () => {
        const page = this.state.page - 1;
        this.setState({page});
    }
    
    goFirstPage = () => {
        const page = 0;
        this.setState({page});
    }

    goLastPage = () => {
        const page = Math.ceil(this.state.services.length/this.state.numServiceItems) - 1;
        this.setState({page});
    }

    reset = () => {
        this.setState({services: this.state.servicesReset});
    }

    /*applyFilter = (num) => {
        var newTitle = '';
        var newList = [];
        if(num==0) {
            newTitle = 'SERVICES';
            newList = this.state.servicesReset.filter(o=>{return o['category'] == 'service'});
        }
        else if(num==1) {
            newTitle = 'TECHNOLOGIES';
            newList = this.state.servicesReset.filter(o=>{return o['category'] == 'tech'});
        }
        else {
            newTitle = 'SERVICES AND TECHNOLOGIES';
            newList = this.state.servicesReset;
        }
        this.setState({title: newTitle, services: newList, page: 0})
    }*/

    render() { 
        var serviceFormatted = this.formatService();
        return ( 
            <div style={{width: '100vw'}}>
            <div class="container-fluid border border-grey" style={{width: '60vw', minWidth: 700}}>
                <div class="row">
                    <div class="col-8">
                        <h1 class="heading ml-2 mt-1" style={{fontSize: 35, color: '#5F6062'}}>{this.state.title}</h1>
                        {serviceFormatted}
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <PageNav decrementPage={this.decrementPage} 
                        incrementPage={this.incrementPage}
                        goFirstPage={this.goFirstPage}
                        goLastPage={this.goLastPage}
                        page={this.state.page}
                        incrementPageTwice={this.incrementPageTwice}
                        lastPage={Math.ceil(this.state.services.length/this.state.numServiceItems)}
                        href='/#/Services'/>
            </div>
            <Footer min={700}/>
            </div>
        );
    }
}
